import { onlyDocumentChars, onlyNumbers } from './string';

export function formatDocument(document: string) {
  if (!document) return '';
  const str = onlyDocumentChars(document);

  if (str.length > 11) {
    return str.replace(
      /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    );
  }

  return str.replace(
    /([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{2})/,
    '$1.$2.$3-$4',
  );
}

export const validateCPF = (document: string) => {
  const cpf = onlyNumbers(document);

  let Soma;
  let Resto;
  Soma = 0;

  if (cpf.length !== 11) return false;
  if (cpf === '00000000000') return false;

  for (let i = 1; i <= 9; i++)
    Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(cpf.substring(9, 10))) return false;

  Soma = 0;
  for (let i = 1; i <= 10; i++)
    Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) Resto = 0;
  if (Resto !== parseInt(cpf.substring(10, 11))) return false;

  return true;
};

const TAMANHO_CNPJ_SEM_DV = 12;
const REGEX_CNPJ = /^[A-Z\d]{12}\d{2}$/;
const VALOR_BASE = '0'.charCodeAt(0);
const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const calculaDvCnpj = (cnpjSemDv: string): string => {
  let somatorioDV1 = 0;
  let somatorioDV2 = 0;

  for (let i = 0; i < TAMANHO_CNPJ_SEM_DV; i++) {
    const asciiDigito = cnpjSemDv.charCodeAt(i) - VALOR_BASE;
    somatorioDV1 += asciiDigito * PESOS_DV[i + 1];
    somatorioDV2 += asciiDigito * PESOS_DV[i];
  }

  const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
  somatorioDV2 += dv1 * PESOS_DV[TAMANHO_CNPJ_SEM_DV];
  const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);

  return `${dv1}${dv2}`;
};

export const validateCNPJ = (cnpjStr: string) => {
  const cnpj = onlyDocumentChars(cnpjStr);

  if (cnpj === '') return false;
  if (!REGEX_CNPJ.test(cnpj)) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  const dvInformado = cnpj.substring(TAMANHO_CNPJ_SEM_DV);
  const dvCalculado = calculaDvCnpj(cnpj.substring(0, TAMANHO_CNPJ_SEM_DV));

  return dvInformado === dvCalculado;
};
